import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      width: '100%',

      borderRadius: 0,
      borderTop: '2px solid #EBECF4',
      borderLeft: '2px solid #EBECF4',
      borderRight: '2px solid #EBECF4',
      backgroundColor: '#F8F8FC',
      '& .MuiStepIcon-root.MuiStepIcon-active': {
        color: theme.palette.success.main,
      },
      '& .MuiStepIcon-root.MuiStepIcon-completed': {
        color: theme.palette.success.main,
      },
      '& .MuiStepLabel-labelContainer': {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'block',
        },
      },
      [theme.breakpoints.up('sm')]: {
        borderRadius: '10px 10px 0px 0px',
      },
    },
    root: {
      width: '100%',
      height: '90px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& .MuiPaper-root': {
        backgroundColor: '#F8F8FC',
      },
    },
    title: {
      fontWeight: 'bold',
      fontSize: 24,
    },
  }),
);

export default useStyles;
